import React from "react";

import cx from "classnames";

import styles from "./LoadingDots.scss";

type LoadingDotsProps = {
  className?: string;
};

const LoadingDots = ({className}: LoadingDotsProps): JSX.Element => {
  return (
    <div
      className={cx(styles.loadingDots, className)}
      role="progressbar"
      aria-label="loading"
    >
      <span className={styles.dot}></span>
      <span className={styles.dot}></span>
      <span className={styles.dot}></span>
    </div>
  );
};

export default LoadingDots;
